import { mapActions } from "vuex";

export default {
  name: "userMixin",
  methods: {
    ...mapActions({
      getCurrentUser: "currentUser/getCurrentUser",
    }),
  },
};
